import type { ScenariaPlan } from "src/model/model";

// AIGeneratedGraph (apps/frontend-webapp/src/common/components/AIGeneratedGraph)
// consumes the legacy scenario markdown shape via its parseMarkdown helper.
// The recap-view scenario node viz reuses that component; this serializer
// converts a ScenariaPlan back to the markdown shape parseMarkdown expects:
//
//   ### Scène n° 1: <title>
//   #### Média: <mediaType>
//   - <interactionName>:
//   - <interactionName>:
//
// parseMarkdown's interaction regex requires either bold-wrapping or a
// trailing colon to capture a bullet — the colon form is unambiguous and
// matches the legacy LLM output convention.
const serializePlanToScenarioMarkdown = (plan: ScenariaPlan): string => {
  const blocks = (plan.sceneOutline || []).map((scene, idx) => {
    const interactionLines = (scene.interactions || [])
      .map((inter) => `- ${inter.type}: ${inter.intent || ""}`.trimEnd())
      .join("\n");
    const lines = [
      `### Scène n° ${idx + 1}: ${scene.title || ""}`.trim(),
      `#### Média: ${scene.mediaType || "image360"}`,
    ];
    if (interactionLines) lines.push(interactionLines);
    return lines.join("\n");
  });
  return blocks.join("\n\n");
};

export default serializePlanToScenarioMarkdown;
